import _ from "lodash";
import React from "react";
import {
  Form,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import { uri, casUrl } from "dictionaries/Env";

export const emptyMsg = "The field can not be empty";

export const prepareLabOptions = list => {
  return _.map(list, option => {
    const { name, id } = option;
    return {
      title: name,
      value: id
    };
  });
};

export const selectedLabsAsArray = list => {
  if (_.isEmpty(list)) return list;
  if (_.every(list, _.isObject)) {
    return _.map(list, lab => lab.labid);
  }
  return list;
};

export const renderReadonlyHorizontalForm = values => {
  if (!values || values.length === 0) return null;

  return (
    <Form horizontal>
      {values.map((elem, i) => {
        const id = String(i);
        return (
          <FormGroup controlId={id} key={i}>
            <Col componentClass={ControlLabel} sm={4}>
              {elem.title}
            </Col>
            <Col sm={8}>
              <FormControl.Static>{elem.value}</FormControl.Static>
            </Col>
          </FormGroup>
        );
      })}
    </Form>
  );
};

export const createMemberLoginLink = () => {
  return `${casUrl}?service=${uri}`;
};

/**
 * Decides whenever component should be updated.
 *
 * Uses user's flag that shows if user able to edit current request.
 *
 * @param {object} props Component properties object
 * @returns boolean
 */
export const shouldUpdate = props => {
  if (!props || !props.user) return false;
  return _.isUndefined(props.user.canEditRequest) ? false : true;
};



// WEBPACK FOOTER //
// ./src/helpers/FormHelper.js